import React, { useEffect, useState } from "react";
import { Row, Col, Card, Divider, Button, List, Alert, Typography } from "antd";
import TePainDuration from "../components/paintrackingform/tePainDuration";
import TePainLocation from "../components/paintrackingform/tePainLocation";
import TePainEntryTitleDate from "../components/paintrackingform/tePainEntryTitleDate";
import TeRatePain from "../components/paintrackingform/teRatePain";
import TePainType from "../components/paintrackingform/tePainType";
import TeReliefMethods from "../components/paintrackingform/teReliefMethods";
import TePainReliefEffectiveness from "../components/paintrackingform/tePainReliefEffectiveness";
import TeAddNotes from "../components/paintrackingform/teAddNotes";
import TeAddMoreDetails from "../components/paintrackingform/teAddMoreDetails";
import TeSymptomTracking from "../components/paintrackingform/teSymptomTracking";
import TeSymptomDuration from "../components/paintrackingform/teSymptomDuration";
import TeTriggerTracking from "../components/paintrackingform/teTriggerTracking";
import TeMoodLevel from "../components/paintrackingform/teMoodLevel";
import TeEnergyLevel from "../components/paintrackingform/teEnergyLevel";
import "../App.css";
import "../index.css";
import "./../styles/painEntryForm.css";
import { useSelector, useDispatch } from "react-redux";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import ErrorList from "../components/Items/ErrorsList";
import {
  handlePainEntryFormSubmission,
  handleResetForm,
  handleUpdateErrorsOfForm,
  submitPainEntry,
} from "../redux-toolkit/slices/painEntryFormSlice";
import { validatePainEntryForm } from "../schemas/PainEntryForm";
import useMultiNotification from "../hooks/useNotification";
import { resetPainLocationsAtCreateForm } from "../redux-toolkit/slices/dashboardSlice";
import { useNavigate } from "react-router-dom";

const CreatePainEntryPage = () => {
  const navigate = useNavigate();
  const { contextHolder, openNotification } = useMultiNotification();
  const painEntryForm = useSelector((state: RootState) => state.painEntryForm);
  const { additionalDetailsClicked, errors, isError } = painEntryForm;
  const dispatch = useAppDispatch();
  const handleFormSubmit = async () => {
    dispatch(handlePainEntryFormSubmission(true));
    const { isError, errors } = validatePainEntryForm(painEntryForm);
    if (isError) {
      dispatch(handlePainEntryFormSubmission(false));
      dispatch(handleUpdateErrorsOfForm({ isError, errors }));
    } else {
      try {
        const response = await dispatch(
          submitPainEntry(painEntryForm)
        ).unwrap();
        const { message } = response;
        if (message) {
          dispatch(handleResetForm(1));
          openNotification(`success`, `Pain Entry`, message);
          setTimeout(() => {
            navigate(`/`);
          }, 3000);
        }
      } catch (error) {
        console.log({ error });
      }
      //let's submit the form here
    }
  };
  useEffect(() => {
    dispatch(resetPainLocationsAtCreateForm(1));
  }, []);
  return (
    <>
      {contextHolder}
      <div className="common-section">
        <div className="container px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center py-8">
            <div className="login-form-container rounded-3xl sm:rounded-[32px] md:rounded-[40px] p-4 sm:p-6 md:p-8 lg:p-12 overflow-hidden relative w-full" style={{ backgroundColor: "var(--neutral-100)" }}>
              <div className="header-content">
                <h3 className="h3 header-title">
                  Create Pain Entry
                </h3>
                <Typography className="h6 text-theme-textsecondary">
                  Track your pain levels, symptoms, and relief methods to better understand your condition.
                </Typography>
              </div>

              <div className="flex justify-start mb-6">
                <svg viewBox="0 0 122 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[92px] md:w-[122px]">
                  <path
                    opacity="0.4"
                    d="M1.46484 6.83613L4.45387 3.7103C7.74598 0.267505 13.38 0.760513 16.0241 4.72277L16.5428 5.50001C19.2423 9.54539 25.1877 9.54539 27.8873 5.5V5.5C30.5869 1.45461 36.5322 1.45461 39.2318 5.5V5.5C41.9314 9.54539 47.8768 9.54539 50.5764 5.5V5.5C53.2759 1.45461 59.2213 1.45461 61.9209 5.5V5.5C64.6205 9.54539 70.5658 9.54539 73.2654 5.5V5.5C75.965 1.45461 81.9104 1.45461 84.61 5.5V5.5C87.3096 9.54539 93.2549 9.54539 95.9545 5.5V5.5C98.6541 1.45461 104.599 1.45461 107.299 5.5V5.5C109.999 9.54539 115.944 9.54539 118.644 5.5L120.534 2.66667"
                    stroke="var(--primary-500)"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              
              <div className="pain-entry-form">
                <div className="flex flex-col gap-5 w-full">
                  {/* Date and Title Section */}
                  <div className="form-section">
                    <TePainEntryTitleDate />
                  </div>

                  {/* Pain Rating Section */}
                  <div className="form-section">
                    <TeRatePain />
                  </div>

                  {/* Pain Location Section */}
                  <div className="form-section">
                    <TePainLocation />
                  </div>

                  {/* Pain Type Section */}
                  <div className="form-section">
                    <TePainType />
                  </div>

                  {/* Pain Duration Section */}
                  <div className="form-section">
                    <TePainDuration />
                  </div>

                  {/* Relief Methods Section */}
                  <div className="form-section">
                    <TeReliefMethods />
                  </div>

                  {/* Relief Effectiveness Section */}
                  <div className="form-section">
                    <TePainReliefEffectiveness />
                  </div>

                  {/* Notes Section */}
                  <div className="form-section">
                    <TeAddNotes />
                  </div>

                  {/* Additional Details Section */}
                  <div className="form-section">
                    <TeAddMoreDetails />
                  </div>

                  {/* Conditional Additional Details */}
                  {additionalDetailsClicked && (
                    <>
                      <div className="form-section">
                        <TeEnergyLevel />
                      </div>
                      <div className="form-section">
                        <TeSymptomTracking />
                      </div>
                      <div className="form-section">
                        <TeSymptomDuration />
                      </div>
                      <div className="form-section">
                        <TeTriggerTracking />
                      </div>
                      <div className="form-section">
                        <TeMoodLevel />
                      </div>
                    </>
                  )}

                  {/* Error Display */}
                  {isError === true && (
                    <div className="mt-6">
                      <ErrorList errors={errors} />
                    </div>
                  )}

                  {/* Submit and Cancel Buttons */}
                  <div className="flex justify-center gap-4" style={{ marginTop: "40px" }}>
                    <button
                      onClick={() => navigate('/')}
                      className="caption2 transition-colors duration-200"
                      style={{ color: 'var(--primary-500)', textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer' }}
                    >
                      Cancel
                    </button>
                    <button
                      disabled={painEntryForm.isSubmitting}
                      onClick={(e) => {
                        e.preventDefault();
                        handleFormSubmit();
                      }}
                      className="btn btn-primary btn-lg"
                    >
                      {painEntryForm.isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatePainEntryPage;
